import { SettingsStateProps } from 'redux/reducers/settings'

const setSettings = (settings: SettingsStateProps | null | {}) => ({
  type: 'SET_SETTINGS',
  ...settings,
})

export default setSettings
